import { mount } from 'svelte';
import BarometreSimplifie from './test-maturite/BarometreSimplifie.svelte';

mount(BarometreSimplifie, {
  target: document.getElementById('barometre-simplifie')!,
});
